module.exports = __webpack_public_path__ + "static/media/102738036_207621113591546_610448375777587681_n.282bf0f2.jpg";